import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../apis/transform/stats"

export function PlayerMinutes({ minutes, assists }: { minutes: number; assists: number }) {
  return (
    <Col className={"colStats"}>
      <Row>
        <Col sm={6} className={"centerColumn"}>
          <Row>
            <Col className={"competitionSeasonValueLarge"}>{`${statNumberToString(minutes)}′`}</Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>Minuti giocati</Col>
          </Row>
        </Col>
        <Col sm={6} className={"centerColumn leftBorder"}>
          <Row>
            <Col className={"competitionSeasonValueLarge"}>{statNumberToString(assists)}</Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>Assist</Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}
